<template>
    <div class="dashboard">
        <div class="l-2-00-t--all l-mb3">
            <div>
                <h1>出社時間一覧</h1>
            </div>
            <div>
                <input v-model="params.date" class="l-w4" type="date" @change="fetchingListWorkTimes()">
            </div>
        </div>
        <table>
            <tr>
                <th v-for="data in tableSet" :key="data.key" :class="data.class">
                    {{ data.head }}
                </th>
                <th class="is-right">&nbsp;</th>
            </tr>
            <tr v-for="(list, index) in listWorkTimes" :key="`list${index}`">
                <td v-for="data in tableSet" :key="`list${index}${data.key}`" :class="data.class">
                    {{ list[data.key] }}
                </td>
                <td class="is-right">
                    <router-link class="button--primary" :to="{ name: 'offices_work_times_update', params: { id: String(list.driver_id), date: params.date }}" type="button" tag="button">変更</router-link>
                </td>
            </tr>
        </table>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    const tableWorkTimes = [
        {
            "class": "",
            "head": "ドライバーID",
            "key": "driver_id",
        },
        {
            "class": "",
            "head": "ドライバー",
            "key": "driver_name",
        },
        {
            "class": "is-right",
            "head": "出勤時間",
            "key": "work_time",
        },
    ];

    export default {
        "mixins": [
            common,
        ],
        data() {
            return {
                "listWorkTimes": [],
                "params": {
                    "date": "",
                },
                "tableSet": tableWorkTimes,
            };
        },
        created() {
            this.setDate();
            this.fetchingListWorkTimes();
        },
        "methods": {
            setDate() {
                // 今日の日付をset
                const today = new Date();
                const year = today.getFullYear();
                const month = ("0" + (today.getMonth() + 1)).slice(-2);
                const date = ("0" + today.getDate()).slice(-2);
                this.params.date = `${year}-${month}-${date}`;
            },
            fetchingListWorkTimes() {
                this.$_requestCancel("SelectDate");
                // 全ドライバー出社時間データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/work_times`,
                    this.$_requestConfig("SelectDate")
                ).then(response => {
                    // ドライバーIDで昇順
                    this.listWorkTimes = response.data.sort((a, b) => a.driver_id - b.driver_id);
                }).catch(() => {
                    this.$_modalError("fetchingWorkTimesError");
                });
            },
        },
    };
</script>
